var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99163 8.5625H2.25829C2.00056 8.5625 1.79163 8.77143 1.79163 9.02917V21.6583C1.79163 21.9161 2.00056 22.125 2.25829 22.125H5.99163C6.24936 22.125 6.45829 21.9161 6.45829 21.6583V9.02917C6.45829 8.77143 6.24936 8.5625 5.99163 8.5625Z",
    stroke: "#004853",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.125,
    cy: 4.1875,
    rx: 2.625,
    ry: 2.1875,
    stroke: "#004853",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 8.82495V10.3124C15.5 6.37493 22.5 8.12494 22.5 13.3749V21.6874C22.5 21.9291 22.3041 22.1249 22.0625 22.1249L18.5625 22.1249C18.3209 22.1249 18.125 21.929 18.125 21.6874V14.2499C18.125 13.3749 17.1914 11.625 15.5 11.6249C13.8086 11.6249 13.3125 13.3749 13.3125 14.2499V21.6874C13.3125 21.9291 13.1166 22.1249 12.875 22.1249H9.375C9.13338 22.1249 8.9375 21.9291 8.9375 21.6874V8.82495C8.9375 8.67998 9.05503 8.56245 9.2 8.56245H13.05C13.195 8.56245 13.3125 8.67998 13.3125 8.82495Z",
    stroke: "#004853",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.efffbbfb17a078c1f2343648a5910092.svg";
export { ForwardRef as ReactComponent };